module.exports = __webpack_public_path__ + "img/bg-dashboard-bluegreen.ce83362e.png";